<template>
  <div>
    <van-nav-bar title="社保公积金明细" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight" />
    <van-row justify="center" type="flex" style="text-align: center; background-color: #FFFFFF;margin: 0px; ">
      <van-col v-if="!show" span="24" style="color: black;">
        <van-search v-model="Searvalue" show-action placeholder="请输入员工姓名" style="height: 48px;box-shadow: 0 2px 12px rgba(100,101,102,.12);" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </van-col>
    </van-row>
    <van-cell :value="timeValue" title="请选择属期" is-link @click="show2 = true" />
    <van-popup v-model="show2" :style="{ height: '30%' }" position="bottom" close-icon="close">
      <van-datetime-picker
        v-model="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        type="year-month"
        title="选择年月"
        @cancel="show2 = false"
        @confirm="_datex(currentDate)"
      />
    </van-popup>

    <van-tabs type="card">
      <van-tab title="社保信息">
        <div v-if="socialx">
          <van-collapse v-for="(list, index) in socialx" v-model="activeNames" :key="index">
            <van-collapse-item :value="list.emp_name" :name="index">
              <template #title>
                <div>
                  社保
                  <van-image :src="iconSrc[0]" style="position: relative;top: 5px;right: 0px;" fit="contain" top="20px" width="20" height="20" />
                </div>
              </template>
              <div style="background-color: #fcf2f4">
                <van-row
                  justify="center"
                  style="text-align: center;height: 30px;line-height: 30px;border-bottom: #B3D4FC 1px solid;border-right: #B3D4FC 1px solid; color: #2980B9;"
                >
                  <van-col span="24">社保信息</van-col>
                </van-row>

                <div class="xa ax">
                  <van-row>
                    <van-col span="6">
                      姓名 :
                      <span style="color: crimson;">{{ list.emp_name }}</span>
                    </van-col>
                    <van-col span="8">基数</van-col>
                    <van-col span="4" style="font-size: 14px;">比例</van-col>
                    <van-col span="6">金额</van-col>
                  </van-row>
                </div>
                <div class="xa">
                  <van-row>
                    <van-col span="4" class="ma xc">养老</van-col>
                    <van-col span="2" class="max xxx">
                      企业
                      <br >
                      <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
                    </van-col>
                    <van-col span="8" class="ma xc axx">{{ list.pension_client_base }}</van-col>
                    <van-col span="2" class="ma xx">
                      {{ list.pension_client_ratio }}%
                      <br >

                      {{ list.pension_person_ratio }}%
                    </van-col>
                    <van-col span="4" class="ma xx mc">
                      {{ list.client_money }}
                      <br >
                      {{ list.person_money }}
                    </van-col>
                  </van-row>
                </div>

                <div class="xa">
                  <van-row>
                    <van-col span="4" class="ma xc">失业</van-col>
                    <van-col span="2" class="max xxx">
                      企业
                      <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
                    </van-col>
                    <van-col span="8" class="ma xc axx">{{ list.unemp_upper_base }}</van-col>
                    <van-col span="2" class="ma xx">
                      {{ list.unemp_client_ratio }}%
                      <br >
                      {{ list.unemp_person_ratio }}%
                    </van-col>
                    <van-col span="4" class="ma xx mc">
                      {{ list.unemp_client_money }}
                      <br >
                      {{ list.unemp_person_money }}
                    </van-col>
                  </van-row>
                </div>

                <div class="xa">
                  <van-row>
                    <van-col span="4" class="ma xc">工伤</van-col>
                    <van-col span="2" class="ma xc" style="font-size: 12px;">企业</van-col>
                    <van-col span="8" class="ma xc axx">{{ list.injuries_upper_base }}</van-col>
                    <van-col span="2" class="ma xc xx" style="text-align: right;font-size: 14px;">{{ list.injuries_client_ratio }}%</van-col>
                    <van-col span="4" class="ma xc xx mc" style="text-align: right;font-size: 14px;">{{ list.injuries_money }}</van-col>
                  </van-row>
                </div>
                <div class="xa">
                  <van-row>
                    <van-col span="4" class="ma xc">医疗</van-col>
                    <van-col span="2" class="max xxx">
                      企业
                      <br >
                      <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
                    </van-col>
                    <van-col span="8" class="ma xc axx ">{{ list.hosp_upper_limit }}</van-col>
                    <van-col span="2" class="ma xx">
                      {{ list.hosp_client_ratio }}%
                      <br >
                      {{ list.hosp_person_ratio }}%
                    </van-col>
                    <van-col span="4" class="ma xx mc">
                      {{ list.hosp_client_upper_money }}
                      <br >
                      {{ list.hosp_person_upper_money }}
                    </van-col>
                  </van-row>
                </div>
                <div class="xa">
                  <van-row>
                    <van-col span="4" class="ma xc" style="color: red;">合计</van-col>

                    <van-col span="7" style="text-align: left;">
                      <span>
                        <span style="color:forestgreen;font-size: 12px;">(个人)</span>
                        <span style="">{{ list.person_total }}</span>
                        <br >
                        <span style="color:firebrick;font-size: 12px;">(企业)</span>
                        {{ list.client_total }}
                      </span>
                      <span style="font-size: 12px;padding-right: 20px;" />
                      <span style="color: darkorange;" />
                      <span style="font-size: 12px;"><span /></span>
                    </van-col>
                    <van-col span="4" class="ma xc" style="color: #008C00;">总计</van-col>
                    <van-col span="6" class="ma xc" style="font-size: 14px;color: orange; text-align: left;">{{ list.total }}</van-col>
                  </van-row>
                </div>
                <div class="xas">
                  <van-row>
                    <van-col span="4" class="ma xc" style="color: darkblue;">社保总计</van-col>
                    <van-col span="12" style="text-align: left; position: relative;top: 12.5px;padding-left: 15px; color: #008C00;">{{ list.totalX }}</van-col>
                  </van-row>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <div v-if="!socialx"><van-empty image="search" description="暂无数据" /></div>
        </div>
        <div>
          <van-tabbar safe-area-inset-bottom>
            <van-pagination v-model="queryCondition.page" :total-items="queryCondition.total" :show-page-size="4" force-ellipses @change="query()" />
          </van-tabbar>
        </div>
      </van-tab>

      <van-tab title="公积金信息">
        <!-- <div v-if="x"></div> -->
        <van-collapse v-for="(list, index) in fund" v-model="activeNames" :key="index">
          <van-collapse-item :value="list.emp_name" :name="index">
            <template #title>
              <div>
                公积金
                <van-image :src="iconSrc[1]" style="position: relative;top: 5px;right: 0px;" fit="contain" top="20px" width="20" height="20" />
              </div>
            </template>
            <div style="background-color: #fcf2f4">
              <div style="background-color: #FFECEC;">
                <van-row justify="center" style="text-align: center;height: 30px;line-height: 30px;border-bottom: brown 1px solid;border-right: brown 1px solid; color: #FF8C00">
                  <van-col span="24">公积金信息</van-col>
                </van-row>
                <div class="xax ax">
                  <van-row>
                    <van-col span="6">
                      姓名 :
                      <span style="color: crimson;">{{ list.emp_name }}</span>
                    </van-col>
                    <van-col span="8">基数</van-col>
                    <van-col span="4" style="font-size: 14px;">比例</van-col>
                    <van-col span="6">金额</van-col>
                  </van-row>
                </div>
                <div class="xa">
                  <van-row>
                    <van-col span="4" class="ma xc">公积金</van-col>
                    <van-col span="2" class="max xxx">
                      企业
                      <span style="border-top: 1px solid gray; display: inline-block; width: 30px;">个人</span>
                    </van-col>
                    <van-col span="8" class="ma xc axx">{{ fund[index].f_base }}</van-col>
                    <van-col span="2" class="ma xx">
                      {{ fund[index].ratio }}%
                      <br >
                      {{ fund[index].ratio }}%
                    </van-col>
                    <van-col span="4" class="ma xx mc">
                      {{ fund[index].fund_client }}
                      <br >
                      {{ fund[index].fund_person }}
                    </van-col>
                  </van-row>
                </div>

                <div class="xas">
                  <van-row>
                    <van-col span="6" class="ma xc" style="color: #FA5151;">公积金总计</van-col>
                    <!-- <van-col span="4" /> -->
                    <van-col span="12" style="text-align: left; position: relative;top: 12.5px;padding-left: 15px; color: #008C00;">{{ fund[index].total_amount }}</van-col>
                    <!-- <van-col span="4" class="ma xc" style="color: #008C00;">总计</van-col>
                    <van-col span="6" class="ma xc" style="font-size: 14px;color: orange; text-align: left;">{{ fund[index].total_amounts }}</van-col> -->
                  </van-row>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div v-if="!fund"><van-empty image="search" description="暂无数据" /></div>

        </van-collapse>
        <div>
          <van-tabbar safe-area-inset-bottom>
            <van-pagination v-model="queryCondition2.page" :total-items="queryCondition2.total" :show-page-size="4" force-ellipses @change="query()" />
          </van-tabbar>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import { fundDetail } from '@/api/Hrfund';
import { Toast } from 'vant';
import { socialList, fundetail } from '@/api/Hrfund';
import { socialDetail } from '@/api/Hrfund';
import { List } from '@/api/Hrclient';
import { Wxlist } from '@/api/Hremployee';
import { conso } from '../../../utils/date.js';
export default {
  name: 'FundDetail',
  data() {
    return {
      iconSrc: ['../../static/icon/社保.png', '../../static/icon/公积金.png'],
      activeNames: ['1'],
      Searvalue: '',
      show3: false,
      social: {
        name: [],
        s_base: 0,
        pension_client_base: 0,
        pension_lower_limit: 0,
        pension_client_ratio: 0,
        pension_person_ratio: 0,
        unemp_upper_base: 0,
        injuries_upper_base: 0,
        bear_upper_base: 0,
        hosp_upper_limit: 0
      },

      fund: [],
      socialx: [],
      social_id: 0,
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',

        begin_consult_date: null,
        end_consult_date: null,
        status: null,
        phone: ''
      },
      queryCondition2: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',

        begin_consult_date: null,
        end_consult_date: null,
        status: null,
        phone: ''
      },
      show2: false,
      show: true,
      show4: false,
      timeValue: sessionStorage.getItem('timeValue')
    };
  },
  beforeMount() {
    this.addDate();
    this.query();
  },
  mounted() {},
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },

    addDate() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = `0${date.month}`;
      }
      const systemDate = date.year + '-' + `${date.month}` + '-' + '01';
      if (this.timeValue === null) {
        this.timeValue = systemDate;
      }
    },
    _datex(value) {
      const xa = value;
      conso(xa);
      this.show2 = JSON.parse(sessionStorage.getItem('show2'));
      this.timeValue = sessionStorage.getItem('timeValue');
      this.query();
    },
    _formatter() {
      this.formatter();
    },
    onSearch() {
      this.queryCondition.page = 1;
      this.query();
      // this.Searvalue = '';
    },
    query() {
      // Wxlist({ id: parseInt(sessionStorage.getItem('emp_id')) }).then(res => {
      //   // this.social.s_base = res.rows[0].s_base;
      //   this.social.name = res.rows[0].name;
      //   sessionStorage.setItem('name', res.rows[0].name);
      // });
      const client_id = parseInt(sessionStorage.getItem('client_id'));

      if (client_id != undefined) {
        List({ client_id }).then(res => {
          sessionStorage.setItem('social_id', res.rows[0].social_id);
          // this.social.social_id = res.rows[0].social_id;
          this.social_id = res.rows[0].social_id;
          if (sessionStorage.getItem('who') === '1') {
            this.social.username = sessionStorage.getItem('username');
          }
          this.socialx = [];
          this.fund = [];
          fundetail({
            client_id,
            fund_id: res.rows[0].ss_fund_id,
            curr_date: this.timeValue,
            emp_name: this.Searvalue ? this.Searvalue : null,
            total: this.queryCondition2.total,
            page: this.queryCondition2.page,
            rows: 10
          }).then(res => {
            if (res.rows !== null) {
              for (let i = 0; i < res.rows.length; i++) {
                this.fund.push({
                  fund_client: parseInt(res.rows[i].fund_client).toFixed(2),
                  fund_person: parseInt(res.rows[i].fund_person).toFixed(2),
                  f_base: res.rows[i].f_base !== undefined ? res.rows[i].f_base : null,
                  total_amounts: parseInt(res.rows[i].total_amount).toFixed(2),
                  emp_name: res.rows[i].emp_name,
                  ratio: Math.floor((res.rows[i].fund_person / res.rows[i].f_base) * 100),
                  total_amount: parseInt(res.obj.total_amount).toFixed(2),
                  total: res.rows.total
                });
              }
            }

            this.queryCondition2.total = res.total || 0;
          });
          socialDetail({
            client_id,
            social_id: res.rows[0].social_id,
            curr_date: this.timeValue,
            emp_name: this.Searvalue ? this.Searvalue : null,
            total: this.queryCondition.total,
            page: this.queryCondition.page,
            rows: 10
          }).then(res => {
            if (res.rows != null) {
              const len = res.rows.length;

              for (let i = 0; i < len; i++) {
                this.show = false;
                const resx = res.rows[i];
                this.socialx.push({
                  emp_name: resx.emp_name,
                  pension_client_base: resx.pension_base,
                  unemp_upper_base: resx.unemp_base,
                  injuries_upper_base: resx.injuries_base,
                  hosp_upper_limit: resx.hosp_base,
                  pension_client_ratio: parseFloat(resx.pension_client_ratio) * 100,
                  pension_person_ratio: parseFloat(resx.pension_person_ratio) * 100,
                  unemp_client_ratio: parseFloat(resx.unemp_client_ratio) * 100,
                  unemp_person_ratio: parseFloat(resx.unemp_person_ratio) * 100,
                  injuries_client_ratio: parseFloat(resx.injuries_client_ratio) * 100,
                  hosp_client_ratio: parseFloat(resx.hosp_client_ratio) * 100,
                  hosp_person_ratio: parseFloat(resx.hosp_person_ratio) * 100,
                  client_money: resx.pension_client,
                  person_money: resx.pension_person,
                  unemp_client_money: resx.unemp_client,
                  unemp_person_money: resx.unemp_person,
                  injuries_money: resx.injuries_client,
                  hosp_client_upper_money: resx.hosp_client,
                  hosp_person_upper_money: resx.hosp_person,
                  person_total: resx.person_total,
                  client_total: resx.client_total,
                  totalX: res.obj.total,
                  total: resx.total
                });
                this.show3 = true;
              }
              this.queryCondition.total = res.total || 0;
            } else if (res.total === 0) {
              this.show = false;
              this.show3 = false;
              this.social = false;
              this.show4 = true;
            }
          });
        });
      }
      socialList({ id: parseInt(sessionStorage.getItem('social_id')) }).then(res => {});
    },

    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {}
  }
};
</script>

<style scoped>
.xa {
  text-align: center;
  margin: 10px 0px;
  border-right: 1px #888888 solid;
  border-bottom: 1px #888888 solid;
}

.xas {
  text-align: center;
  margin: 10px 0px;
  background-color: floralwhite;

  border-right: 1px royalblue solid;
  border-bottom: 1px royalblue solid;
}
.xax {
  text-align: center;
  margin: 10px 0px;
  border-right: 1px forestgreen solid;
  border-bottom: 1px forestgreen solid;
}
.ax {
  margin: 10px 0px;
  height: 41.6px;
  line-height: 41.6px;
}
.he {
  line-height: 40px;
  height: 40px;
}
.ma {
  margin-top: 2px;
  text-align: right;
}
.max {
  margin-top: 2px;
  text-align: center;

  font-size: 14px;
}
.xc {
  line-height: 41.6px;
  height: 41.6px;
  text-align: center;
  font-size: 14px;
  /* border: 1px solid beige; */
}
.xx {
  height: 41.6px;
  margin-left: 20px;
  color: seagreen;
  font-size: 14px;
}
.xxx {
  height: 41.6px;
  text-align: center;
  font-size: 12px;
}
.mc {
  color: darkorange;
  font-size: 14px;
}
.axx {
  color: #008c00;
  font-size: 14px;
}
.van-tabbar--fixed >>> .van-pagination {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/fund/fund-detail.vue